export enum WISTIA_VIDEOS {
  WEIGHT_RESULTS_EXPECTATIONS = 'j715lm88io',
  WEIGHT_COMPREHENSIVE_PROGRAM = 't6jy1n21sg',
  WEIGHT_DIABETES_RISK = 'og714v9c9h',
  WHAT_IS_SAXENDA = '9azxxhjjih',
  HOW_TO_ADMINISTER_SAXENDA = '1homu7axim',
  SAXENDA_MANAGING_SIDE_EFFECTS = '18t1hgpran',
  HOW_TO_ADMINISTER_OZEMPIC = 'khjf93kqhx',
}
